<template>
  <draggable
    class="v-list v-theme--light bg-transparent v-list--density-default v-list--one-line list page-nav-drag item-group pa-0 v-list-item--nav page-nav-drag item-group pa-0 v-list-item--nav d-block"
    :tag="'div'" :list="pages" handle=".handle" :group="{ name: 'drag-dash-pages', pull: true, put: true }"
    :empty-insert-threshhold="500" v-bind="dragOptions">
    <template #item="{ index, element }">
      <v-list-item class="v-list-item item pa-0 d-block" color="var(--primary)">
        <div class="v-list-item-title my-auto" @click="selectTab(element.id)">
          <i class="fal fa-md fa-grip-vertical handle mr-2"></i>
          <v-avatar class="rounded-0 mr-2 my-auto" color="primary" size="24">{{
      index
    }}</v-avatar>
          <p class="my-auto">{{ element.page_title }}</p>

          <v-menu width="200">
            <template v-slot:activator="{ props }">
              <v-btn class="on-hover btn-sm ml-auto rounded-0" size="small" icon variant="text" color="var(--primary)"
                v-bind="props">
                <i class="fal fa-xl fa-ellipsis-v"></i>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="emitEditPage(element)">
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <v-list-item @click="emitDuplicatePage(element)">
                <v-list-item-title>Duplicate</v-list-item-title>
              </v-list-item>
              <v-list-item color="danger" @click="emitDeletePage(element.id)">
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-list-item>
    </template>
  </draggable>

  <!-- Dialog for Editing Page Title -->
  <v-dialog v-model="dialog" max-width="400px" content-class="card card-sm">
    <h3>Edit page title</h3>

    <div class="py-3">
      <v-text-field v-model="editedPageTitle" label="Page title" variant="solo" :rules="[rules.required]" required />
    </div>
    <div class="text-right">
      <v-btn class="btn mr-2" color="var(--neutral)" variant="text" @click="closeDialog">Cancel</v-btn>

      <v-btn class="btn text-white" color="var(--primary)" elevation="0" @click="savePageTitle">Save</v-btn>
    </div>
  </v-dialog>
</template>

<script>


export default {
  components: {

  },
  name: "dashboardScreen",
  props: {
    pages: {
      required: false,
      type: Array,
    },
    tabview: {
      type: Number,
    },
    dashboardview: {
      type: Number,
    },
  },
  data() {
    return {
      dialog: false,
      editedPageId: null,
      editedPageTitle: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    selectTab(id) {
      this.$emit("tab-selected", id);
    },
    emitEditPage(element) {
      this.editedPageId = element.id;
      this.editedPageTitle = element.page_title;
      this.dialog = true;
    },
    savePageTitle() {
      this.$emit("edit-page", {
        id: this.editedPageId,
        title: this.editedPageTitle,
      });
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.editedPageId = null;
      this.editedPageTitle = "";
    },
    emitDuplicatePage(element) {
      this.$emit("duplicate-page", element);
    },
    emitDeletePage(id) {
      this.$emit("delete-page", id);
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>
